import {Component, Input, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'v-asm-customer-search-form',
  templateUrl: './asm-customer-search-form.component.html',
  styleUrls: []
})
export class AsmCustomerSearchFormComponent {

  private inputControl = new FormControl();
  inputForm = new FormGroup({customer: this.inputControl});

  @Output() get keyupEvent() {
    return this.inputControl.valueChanges;
  }

  @Input() set inputValue(name: string) {
    this.inputControl.patchValue(name,
      {
        emitEvent: false,
        emitModelToViewChange: true,
        emitViewToModelChange: true
      });
  }

  @Input() processing = false;
  @Input() labelText: string;
}
